
import ReceptionFripeMag from "@/ReceptionFripeMag.vue";
import Fripe from "@/Fripe.vue";
import NotFound from "@/NotFound.vue";
import Produits from "@/Produits.vue";
import Login from "@/Login.vue";
import Negoce from "@/NegoceOrder.vue";
import { createRouter, createWebHashHistory ,createWebHistory } from "vue-router";
import ValidationReception from "@/ValidationReception.vue";
import Frep from "@/Frep.vue";
import ImportExcel from "@/ImportExcel.vue";
import ImportText from "@/ImportText.vue";
import Achat from "@/Achat.vue";
import Achat12 from "@/Achat12.vue";
import Test from "@/Test.vue";
import Stats from "@/Statistics.vue";
import VirtualTable from '@/components/PivotInfo.vue';
import Crosspoint from "@/components/Crosspoint.vue";
import Statistiques from "@/components/Statistiques.vue";
import Home from "@/components/Home.vue";
import FripeReponse from "@/components/FripeReponse.vue";
import store from "@/store";

const routes=[
  
  {path:'/' , name: 'login',component : Login},
  {path:'/home' , name: 'home',component : Home},
  {path:'/login' , name: 'login1',component : Login},
  {path:'/edisac' ,name: 'produits', component : Produits},
  {path:'/fripe' , name: 'fripe',component : Fripe},
  {path:'/negoce' , name: 'negoce',component : Negoce},
  {path:'/negoce/:id/:num/:token' , name: 'negoceid', component: Negoce, props: true},
  {path:'/frep' , name: 'frep',component : Frep},
  {path:'/import' , name: 'import',component : ImportExcel},
  {path:'/importxt' , name: 'importxt',component : ImportText},
  {path:'/achat' , name: 'achat',component : Achat},
  {path:'/achat12' , name: 'achat12',component : Achat12},
  {path:'/test' , name: 'test',component : Test},
  {path:'/reception' , name: 'receptionFripeMag',component : ReceptionFripeMag},
  {path:'/validation' ,name: 'validationReception', component : ValidationReception},
  {path:'/crm' ,name: 'Statistics', component : Stats},
  {path:'/table' ,name: 'Table', component : VirtualTable},
  {path:'/crp' ,name: 'Table', component : Crosspoint},
  {path:'/friperesponse' ,name: 'FripeReponse', component : FripeReponse},
  {path:'/statistiques' ,name: 'Statistiques', component : Statistiques},
  {path: '/:pathMatch(.*)*', name: 'NotFound', component: Login}
  ]


const router=createRouter({
  history:createWebHashHistory (import.meta.env.BASE_URL),
  routes});

router.beforeEach(async (to, from, next) => {
  try {
    // Récupérer l'IP via une API
    const response = await fetch('https://api.ipify.org?format=json')
    const data = await response.json()
    
    // Stocker dans les meta de la route
    to.meta.clientIP = data.ip
    // console.log(data);
    store.commit('setClientIP',data.ip)
    // Ou dans le store si vous en avez un
    // store.commit('setClientIP', data.ip)
  } catch (error) {
    console.error('Erreur récupération IP:', error)
    to.meta.clientIP = 'unknown'
  }
  
  next()
})

export default router;